import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage } from '~/features/auth/pages/login-page';

/**
 * Search schema for /login. `redirect` is the original URL the user tried
 * to visit before being bounced here by `requireAuth`. Validated again
 * post-auth via safeRedirectTarget — so this only needs to allow strings.
 * `bridgeFor` + `bridgeProvider` mark this load as the SSO-bridge entry
 * point for a localhost dev session; both are re-validated by sso-bridge
 * before any navigation, so loose strings are fine here.
 */
const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  bridgeFor: z.string().optional(),
  bridgeProvider: z.string().optional(),
  /** Error message passed from the email-verification flow on failure. */
  error: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  component: LoginPage,
});
